export default __webpack_public_path__ + "static/media/orangeBtn.c86c0d94.svg";